import { c as _c } from "react/compiler-runtime";
import type { FilterType, SortType, ViewMode } from '../_types/types';
import { PolicyList } from './PolicyList';
import { PolicyTimeline } from './PolicyTimeline';
interface PolicyContentProps {
  filter?: FilterType;
  sort: SortType;
  viewMode: ViewMode;
}
export const PolicyContent = t0 => {
  const $ = _c(4);
  const {
    filter,
    sort,
    viewMode
  } = t0;
  if (viewMode === "timeline") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <PolicyTimeline />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== filter || $[2] !== sort) {
    t1 = <PolicyList filter={filter} sort={sort} />;
    $[1] = filter;
    $[2] = sort;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};